import AbstractCommand from '../AbstractCommand';
import invoiceConceptsArchivedGet from '../../requests/invoiceConceptsArchivedGet';
import InvoiceConceptModel from '../../stores/models/InvoiceConceptModel';

/**
 *
 */
export default class GetArchivedInvoicesConceptCommand extends AbstractCommand {
	/**
	 *
	 * @param invoicesConceptStore InvoicesConceptStore
	 * @param companyId Number
	 */
	constructor(invoicesConceptStore, companyId) {
		super();

		this.invoicesConceptStore = invoicesConceptStore;
		this.companyId = companyId;
	}

	/**
	 *
	 * @param success
	 * @param error
	 */
	execute(success, error) {
		return invoiceConceptsArchivedGet(this.companyId)
			.then((response) => {
				this._parseResult(response);

				if (success) {
					success(response);
				}
			})
			.catch((err) => {
				if (error) {
					error(err);
				}
			});
	}

	/**
	 *
	 * @param response
	 * @private
	 */
	_parseResult(response) {
		this.invoicesConceptStore.reset();
		const invoices = [];
		response.list.forEach((data) => {
			invoices.push(InvoiceConceptModel.parseInvoiceConceptData(data));
		});

		this.invoicesConceptStore.addAll(invoices);
	}
}
